import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const headerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: 'clamp(8px, 2vw, 28px) clamp(12px, 3vw, 32px)',
  background: 'rgba(255,255,255,0.85)',
  boxShadow: '0 1px 8px 0 rgba(0,0,0,0.04)',
  position: 'sticky',
  top: 0,
  zIndex: 100,
};

const downloadBtnStyle = {
  background: '#0071e3',
  color: '#fff',
  border: 'none',
  borderRadius: 'clamp(18px, 4vw, 22px)',
  padding: 'clamp(6px, 2vw, 10px) clamp(16px, 4vw, 28px)',
  fontSize: 'clamp(14px, 3vw, 17px)',
  fontWeight: 500,
  cursor: 'pointer',
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.08)',
  transition: 'background 0.2s',
};

export default function Header() {
  const location = useLocation();
  const isDownloadPage = location.pathname === '/download';

  return (
    <header style={headerStyle} className="responsive-header">
      {!isDownloadPage && (
        <Link to="/download" style={{ textDecoration: 'none' }}>
          <button type="button" style={downloadBtnStyle} className="responsive-button">
            Download
          </button>
        </Link>
      )}
    </header>
  );
}
